import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { classLevels } from '../mock';

export default function Classes() {
  return (
    <section id="classes" className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[#E64B2B] uppercase tracking-[0.25em] font-black text-xs">Classes we cover</span>
          <h2 className="mt-3 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">From <span className="text-[#4FB3B8]">crayons</span> to <span className="text-[#E64B2B]">college prep</span>.</h2>
          <p className="mt-4 text-[#2C3E50]/75 text-lg">Pick a stage. We’ll match you with a tutor who specialises in it.</p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {classLevels.map((c, i) => {
            const accents = ['paper-shadow-yellow', 'paper-shadow-teal', 'paper-shadow-red', 'paper-shadow-yellow', 'paper-shadow-teal', 'paper-shadow-red'];
            const dots = ['#F4B93E', '#4FB3B8', '#E64B2B', '#F4B93E', '#4FB3B8', '#E64B2B'];
            return (
              <div key={c.level} className={`relative bg-white border-2 border-[#2C3E50] rounded-2xl p-6 ${accents[i]} hover:-translate-y-1`}>
                <div className="tape" />
                <div className="flex items-center justify-between">
                  <span className="text-xs uppercase tracking-widest font-black text-[#2C3E50]/60">{c.badge}</span>
                  <span className="w-3 h-3 rounded-full" style={{ background: dots[i] }} />
                </div>
                <h3 className="mt-3 text-2xl font-black text-[#2C3E50]">{c.level}</h3>
                <p className="mt-2 text-[#2C3E50]/75 font-medium">{c.desc}</p>
                <a href="#contact" className="mt-5 inline-flex items-center gap-1 font-bold text-[#E64B2B] hover:gap-2">
                  Enquire <ArrowUpRight size={16} />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
